import React from 'react';
import { useInView } from 'react-intersection-observer';

export interface WithLazyLoadingInjectedProps {
  isInViewport: boolean;
  setLazyRef: ((node?: Element | null) => void) | null;
}

interface WithLazyLoadingOptions {
  defaultLazy?: boolean;
}

interface LazyLoadingOwnProps {
  lazy?: boolean;
  lazyBuffer?: number;
  lazyContainerRef?: Element | null;
  lazyTriggerOnce?: boolean;
}

export default function withLazyLoading({
  defaultLazy = false
}: WithLazyLoadingOptions = {}) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  return <C extends React.ComponentType<any>>(WrappedComponent: C) => {
    type ExternalProps = Omit<
      React.ComponentProps<C>,
      keyof WithLazyLoadingInjectedProps
    > &
      LazyLoadingOwnProps;

    function LazyLoadedComponent({
      lazy = defaultLazy,
      lazyBuffer = 0,
      lazyContainerRef = null,
      lazyTriggerOnce = true,
      ...props
    }: ExternalProps) {
      let [ref, inView] = useInView({
        triggerOnce: lazyTriggerOnce,
        rootMargin: `${lazyBuffer}px`,
        root: lazyContainerRef
      });

      if (!lazy || CONFIG?.isTest || window.__DPL_BOT_UA) {
        ref = null as any;
        inView = true;
      }

      return (
        <WrappedComponent
          {...(props as any)}
          isInViewport={inView}
          setLazyRef={ref}
        />
      );
    }

    LazyLoadedComponent.WrappedComponent = WrappedComponent;

    return LazyLoadedComponent;
  };
}
